// iter86.83 — Shared pills/chips for the Values Engine + governance views.
// Split out of ValuesAndUATCards.jsx (942-line bundle) during the cleanup pass.
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

export const VERDICT_PILL = {
    clear:        { pill: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40", label: "Clear" },
    ack_required: { pill: "bg-amber-500/15 text-amber-300 border-amber-500/40",       label: "Warnings" },
    block_arm:    { pill: "bg-rose-500/15 text-rose-400 border-rose-500/40",           label: "BLOCK" },
};

export function StatusIcon({ status }) {
    if (status === "pass") return <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />;
    if (status === "warn") return <AlertTriangle className="w-4 h-4 text-amber-400 shrink-0" />;
    if (status === "waived") return <AlertTriangle className="w-4 h-4 text-violet-400 shrink-0" />;
    if (status === "notice") return <AlertTriangle className="w-4 h-4 text-sky-400 shrink-0" />;
    return <XCircle className="w-4 h-4 text-rose-400 shrink-0" />;
}

export const POSTURE_PILL = {
    blocked: "bg-rose-500/15 text-rose-300 border-rose-500/40",
    waived:  "bg-violet-500/15 text-violet-300 border-violet-500/40",
    warn:    "bg-amber-500/15 text-amber-300 border-amber-500/40",
    notice:  "bg-sky-500/15 text-sky-300 border-sky-500/40",
    ok:      "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
};

export function SeverityChip({ severity }) {
    const cls = severity === "critical"
        ? "bg-rose-600/20 text-rose-300 border-rose-500/60"
        : severity === "high"
            ? "bg-rose-500/10 text-rose-400 border-rose-500/40"
            : severity === "med"
                ? "bg-amber-500/10 text-amber-400 border-amber-500/40"
                : "bg-zinc-700/30 text-zinc-400 border-zinc-700";
    return (
        <span className={`pill text-[9px] font-bold uppercase border ${cls}`}>{severity}</span>
    );
}
